"use client"

import { ReactNode } from "react"

import { Dialog, DialogContent } from "@/components/ui/dialog"
import { useRouter } from "next/navigation"

import { useModal } from "connectkit"

/**
 * This is a wrapper for the NFTModal componennt.
 *
 * This needs to be separate because:
 * 1) it's a client component
 * 2) It does an animation when it opens, so the fallback and the real body need to be
 * children of this.
 */
export default function NFTModalOuterDialog(props: { children: ReactNode }) {
  const router = useRouter()

  /**
   * If the wallet connect modal is open, don't close the Collect modal.
   *
   * For some reason it always closes by default.
   */
  const { open: forceStayOpen } = useModal()

  return (
    <Dialog
      defaultOpen
      open
      onOpenChange={() => {
        if (forceStayOpen) return
        router.back()
      }}
    >
      <DialogContent className="sm:max-w-[800px] p-0 sm:max-h-[90vh] ">
        {props.children}
      </DialogContent>
    </Dialog>
  )
}
